import { bootToolPage } from '../lib/boot-tool'
import { collectMetrics, onMetricsChange } from '../lib/metrics'
import { openStage } from '../lib/stage'
import { stageMarkup } from '../lib/stage-html'
import { t } from '../i18n/dictionaries'

const locale = bootToolPage('safe-area')
document.body.insertAdjacentHTML('beforeend', stageMarkup({ controls: ['exit', 'hide'] }))
document.querySelectorAll<HTMLElement>('[data-stage-root] [data-i18n]').forEach((node) => {
  const key = node.dataset.i18n
  if (key) node.textContent = t(locale, key)
})

function paint(): void {
  const m = collectMetrics().safeArea
  ;(['top', 'right', 'bottom', 'left'] as const).forEach((side) => {
    const node = document.querySelector(`[data-sa="${side}"]`)
    if (node) node.textContent = `${m[side].toFixed(1)}px`
  })
}

paint()
onMetricsChange(paint)

document.querySelector('[data-action="start"]')?.addEventListener('click', () => {
  const stage = document.querySelector<HTMLElement>('[data-stage-root]')
  const canvas = document.querySelector<HTMLElement>('[data-stage-canvas]')
  if (!stage || !canvas) return
  const m = collectMetrics().safeArea
  canvas.style.background = '#102018'
  canvas.replaceChildren()
  const overlay = document.createElement('div')
  overlay.style.cssText = `position:absolute;inset:0;border-style:solid;border-color:rgb(61 189 180 / 0.55);border-width:${m.top}px ${m.right}px ${m.bottom}px ${m.left}px;box-sizing:border-box`
  const note = document.createElement('div')
  note.style.cssText =
    'position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);color:#d9fff6;font:500 15px Outfit,sans-serif;text-align:center'
  note.textContent = `safe-area\n${m.top}/${m.right}/${m.bottom}/${m.left}`
  canvas.append(overlay, note)
  const close = openStage(stage, {
    onExit: () => close(),
  })
})
